const Events = () => import(/* webpackChunkName: "events-view" */ '@/components/events');

const EVENTS_ROUTES = [
  {
    path: '/events',
    name: 'events',
    component: Events
  }
];

export default EVENTS_ROUTES;
